import GeneralModel from './GeneralModel';
import mainAPI from '../api/MainAPI';

export default class DrugTypeModel extends GeneralModel {
	constructor(socket) {
		super('drug_type', socket, async ()  => await mainAPI.drug_type.all_with_allowed(), 'drug_types');
	}

	allowed = () => {
		const isAllowed = {};
		for (let i in this.Objects) {
			if (this.Objects[i].allowed) {
				isAllowed[i] = this.Objects[i];
			}
		}
		return isAllowed;
	};
}



// WEBPACK FOOTER //
// ./src/model/DrugTypeModel.js